module.exports = __webpack_public_path__ + "static/media/banner-kalendarium_150x300.3e1adc61.png";